module.exports = __webpack_public_path__ + "img/arrow-up-right-square-fill.dd58fec2.svg";